(function (angular, app) {
    "use strict";

    // Heading
    angular.module(app.modules.view.name)
       .directive(app.modules.view.directives.faq, faqDirective);

    faqDirective.$inject = [];

    function faqDirective() {
        return {
            restrict: "E"
           , templateUrl: "app/view/directives/faq.html"
           , link: function (scope, element, attrs) {

                scope.isFAQ = app.Branding.isFAQ;
                scope.siteId = app.Branding.siteId;

            }
        }
    }


}(angular, app));
